import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateDispatchIssueCausedByInput,
  CreateDispatchIssueCausedByResponse,
  MutationCreateDispatchIssueCausedByBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateDispatchIssueCausedBy } from '@/features/IssueHistory/api/queries/CreateDispatchIssueCausedBy';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateDispatchIssueCausedByInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateDispatchIssueCausedByResponse>;
}

// CreateDispatchIssueCausedBy Service
export const { createDispatchIssueCausedBy, useCreateDispatchIssueCausedBy } = ((): {
  createDispatchIssueCausedBy: ServiceMethod;
  useCreateDispatchIssueCausedBy: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateDispatchIssueCausedBy).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateDispatchIssueCausedByInput[], options?: ConnectionOptions): Promise<CreateDispatchIssueCausedByResponse> => {
        const args: MutationCreateDispatchIssueCausedByBulkArgs = {
          input: {
            values: payload,
          },
        };
        const opts = { merge: options?.merge ? 'createDispatchIssueCausedByBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('createDispatchIssueCausedByBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchIssueCausedBy: fetch,
    useCreateDispatchIssueCausedBy: useService,
  };
})();
